<template>
  <div>
    <v-card class="sf-card"
            flat>
      <div class="sf-card__header">
        <h2 class="sf-card__title">{{ $t('additionalGuests') }}</h2>
      </div>
      <v-card-text class="sf-card__body">
        <p class="sf-muted">{{ $t('guestCodeHint') }}</p>
        <v-form ref="form">
          <div v-for="guest in slots"
               v-bind:key="guest.slot"
               v-bind:class="{ 'mt-6': guest.slot > 1 }">
            <h3 class="sf-section-title">{{ slotTitle(guest.slot) }}</h3>
            <v-row class="sf-form-row">
              <v-col cols="12" sm="6">
                <v-text-field dense hide-details="auto"
                              outlined
                              v-bind:label="$t('givenName')"
                              v-model="customer[guest.fields.givenName]" />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field dense hide-details="auto"
                              outlined
                              v-bind:label="$t('familyName')"
                              v-model="customer[guest.fields.familyName]" />
              </v-col>
              <v-col cols="12">
                <v-text-field dense hide-details="auto"
                              outlined
                              v-bind:label="$t('email')"
                              v-model="customer[guest.fields.email]" />
              </v-col>
              <v-col cols="12"
                     sm="6"
                     v-if="guest.hasData">
                <div class="sf-field-label">{{ $t('invitationCode') }}</div>
                <p class="sf-code mb-0"
                   v-if="guest.invitationCode != null">{{ guest.invitationCode }}</p>
                <p class="sf-muted mb-0"
                   v-else>{{ $t('codeAssignedOnSave') }}</p>
              </v-col>
              <v-col cols="12"
                     sm="6"
                     v-if="guest.hasData && guest.invitationCode != null">
                <v-checkbox color="primary"
                            class="my-0"
                            hide-details="auto"
                            v-bind:label="$t('wasAttending')"
                            v-model="customer[guest.fields.wasAttending]" />
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import { guestSlots } from '@/utils/customer-guests'

  export default {
    computed: {
      rules() {
        return {
          required: v => !!v || this.$t('form.required')
        }
      },
      // Reaktiv: hängt an allen Gast-Feldern des Kunden
      slots() {
        return guestSlots(this.customer)
      }
    },
    methods: {
      slotTitle(slot) {
        if (slot === 1) {
          return this.$t('firstGuest')
        }

        if (slot === 2) {
          return this.$t('secondGuest')
        }

        return `${this.$t('guest')} ${slot}`
      },
      validate() {
        return this.$refs.form.validate()
      }
    },
    name: 'CustomerAdditionalGuestsEditCard',
    props: {
      customer: Object
    }
  }
</script>

<style scoped>
  .sf-field-label {
    color: var(--sf-text-muted, #6b7280);
    font-size: .75rem;
    margin-bottom: 4px;
  }

  .sf-code {
    background: var(--sf-surface-muted);
    border: 1px solid var(--sf-border);
    border-radius: 10px;
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    font-size: .9375rem;
    letter-spacing: .04em;
    padding: 10px 14px;
    user-select: all;
  }
</style>

<i18n>
  {
    "de": {
      "additionalGuests": "Weitere Gäste",
      "codeAssignedOnSave": "Der Einladungscode wird beim Speichern vergeben.",
      "email": "E-Mail-Adresse",
      "familyName": "Nachname",
      "firstGuest": "Erster Gast",
      "givenName": "Vorname",
      "guest": "Gast",
      "guestCodeHint": "Jeder Gast erhält einen eigenen Einladungscode mit denselben Rechten wie der Kunde. Der Code wird automatisch vergeben, sobald ein Gast eingetragen und gespeichert ist; E-Mails an Gäste enthalten jeweils ihren eigenen Code.",
      "invitationCode": "Einladungscode",
      "secondGuest": "Zweiter Gast",
      "wasAttending": "Vor Ort"
    },
    "en": {
      "additionalGuests": "Additional guests",
      "codeAssignedOnSave": "The invitation code is assigned when saving.",
      "email": "Email",
      "familyName": "Family name",
      "firstGuest": "First guest",
      "givenName": "Given name",
      "guest": "Guest",
      "guestCodeHint": "Each guest receives their own invitation code with the same rights as the customer. The code is assigned automatically once a guest is entered and saved; emails to guests contain their own code.",
      "invitationCode": "Invitation code",
      "secondGuest": "Second guest",
      "wasAttending": "On site"
    }
  }
</i18n>
